import { isConfigReport, isUnifiedEventsReport } from 'reporting-data/tsTypes/reportTypes';
import { isSearchReport } from 'reporting-data/report/configReportGetters';
import { useCrmObjectTableReportComponent } from './ProvideCrmObjectTableReportComponent';
export const useIsCrmObjectTableSupported = ({
  tableReport
}) => {
  const maybeCrmObjectTableComponent = useCrmObjectTableReportComponent();

  //If there is some app that we have not updated to include ProvideCrmObjectTableReportComponent, we should fall back to what exists today.
  //This is to be expected in early development, but eventually we will want to change this to an error that we be alerted on.
  //
  //ProvideCrmObjectTableReportComponent/useCrmObjectTableReportComponent internally does a gate check
  //meaning if maybeCrmObjectTableComponent is defined the user is ungated already.
  //we do not need to do a gate check within this hook
  if (!maybeCrmObjectTableComponent) {
    return false;
  }
  if (!isConfigReport(tableReport)) {
    return false;
  }
  if (!isSearchReport(tableReport)) {
    return false;
  }
  if (isUnifiedEventsReport(tableReport)) {
    return false;
  }
  return true;
};